/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Link_20labInputs */

const en_quick_link_20lab = /** @type {(inputs: Quick_Link_20labInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20LAB`)
};

const ar_quick_link_20lab = /** @type {(inputs: Quick_Link_20labInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20LAB`)
};

const bn_quick_link_20lab = /** @type {(inputs: Quick_Link_20labInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20LAB`)
};

const de_quick_link_20lab = /** @type {(inputs: Quick_Link_20labInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20LAB`)
};

const es_quick_link_20lab = /** @type {(inputs: Quick_Link_20labInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20LAB`)
};

const fr_quick_link_20lab = /** @type {(inputs: Quick_Link_20labInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20LAB`)
};

const pt_quick_link_20lab = /** @type {(inputs: Quick_Link_20labInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20LAB`)
};

const zh_quick_link_20lab = /** @type {(inputs: Quick_Link_20labInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20LAB`)
};

const tr_quick_link_20lab = /** @type {(inputs: Quick_Link_20labInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20LAB`)
};

const ru_quick_link_20lab = /** @type {(inputs: Quick_Link_20labInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20LAB`)
};

const pl_quick_link_20lab = /** @type {(inputs: Quick_Link_20labInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20LAB`)
};

/**
* | output |
* | --- |
* | "20LAB" |
*
* @param {Quick_Link_20labInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const quick_link_20lab = /** @type {((inputs?: Quick_Link_20labInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Link_20labInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_quick_link_20lab(inputs)
	if (locale === "bn") return bn_quick_link_20lab(inputs)
	if (locale === "de") return de_quick_link_20lab(inputs)
	if (locale === "es") return es_quick_link_20lab(inputs)
	if (locale === "fr") return fr_quick_link_20lab(inputs)
	if (locale === "pt") return pt_quick_link_20lab(inputs)
	if (locale === "zh") return zh_quick_link_20lab(inputs)
	if (locale === "tr") return tr_quick_link_20lab(inputs)
	if (locale === "ru") return ru_quick_link_20lab(inputs)
	if (locale === "pl") return pl_quick_link_20lab(inputs)
	return en_quick_link_20lab(inputs)
});